import { Container, Loader, Logo, Spinner, Spinner2 } from "./style.js";
import LogoWhite from "../../Assets/images/logo-white.png";

const LoadingFull = ({ height="25vh" }) => {
  return (
    <Container height={height}>
      <Logo src={LogoWhite} />
      <Loader>
        <Spinner />
        <Spinner2 />
      </Loader>
    </Container>
  );
};

export default LoadingFull;
